import "./css/inbenta-core.css";
import importScript from "./js/helpers/import-script.js";
import getSDKScript from "./js/helpers/get-sdk-script.js";
import buildSDK from "./js/helpers/build-sdk.js";
import { buildConfig } from "./conf/builder";
import * as omit from "lodash.omit";

declare global {
  interface Window {
    inbChatbotAppSdk: any;
    resetSession: any;
    oldApp: any;
    startChatbot: any;
    currentApp: any;
    SDKHCAdapter: any;
    InbentaChatbotSDK: any;
  }
}

const STORAGE_CHATBOT_ID = "inbenta-chatbot/currentChatbotID";
const STORAGE_HM_INSTANCE = "inbenta-chatbot/currentHMInstance";
const STORAGE_HM = "inbenta-chatbot/currentHM";

const buildComparableConfig = (config) => {
  // El código de inbenta modifica las configuraciones agregando un vector de adaptadores
  // esto hace que la comparación falle y por ello lo ignoramos
  return {
    sdkConfig: omit(config.sdkConfig, "adapters"),
    appConfig: config.appConfig,
  };
};

const isSameConfig = (configA, configB) => {
  return (
    JSON.stringify(buildComparableConfig(configA)) ===
    JSON.stringify(buildComparableConfig(configB))
  );
};

const startChatbot = ({ configProfile, environment, forceRecreate = false }) => {
  const config = buildConfig(configProfile, environment);
  // Set app according to chatbotContext
  window.oldApp = window.currentApp ?? {};
  // Check if conf file exists
  const app = config;
  window.currentApp = app;

  // Check if escalation is in progress, if so, abort to avoid multiple escalations
  const blockEscalation =
    window.localStorage.getItem("block-escalation") ?? "false";
  if (blockEscalation === "true") {
    // console.log('Escalation in progress, aborting startChatbot');
    return;
  }

  // Load core SDK if not loaded
  if (
    typeof window.InbentaChatbotSDK === "undefined" ||
    typeof window.SDKHCAdapter === "undefined"
  ) {
    // console.log('Loading core SDK');
    const sdkScript = getSDKScript(app.sdkIntegration);
    importScript(sdkScript, () => {
      // console.log('Core SDK loaded');
      // Run startChatbot again after the core SDK is loaded
      startChatbot({ configProfile, environment, forceRecreate });
    });
    return;
  }

  // console.log('startChatbot called with chatbotContext: ', chatbotContext);
  // console.log('Current config: ', app);

  // Reset session if forceRecreate is true
  if (forceRecreate) {
    // console.log('Resetting SDK');
    window.resetSession();
    document.getElementById("inbenta-bot-sdk").remove();
    startChatbot({ configProfile, environment, forceRecreate: false });
    return;
  }

  // Build the SDK with the correct config if it doesn't exist
  if (!document.getElementById("inbenta-bot-sdk")) {
    buildSDK(app);
  } else if (!isSameConfig(window.oldApp, app)) {
    // Rebuild the SDK if the config has changed
    window.resetSession();
    document.getElementById("inbenta-bot-sdk").remove();
    buildSDK(app);
  }

  // This will run every time this function is called
  document.cookie = "SameSite=none; Secure";

  window.localStorage.setItem(STORAGE_CHATBOT_ID, app.sdkConfig.chatbotId);
  window.localStorage.setItem(STORAGE_HM_INSTANCE, app.appConfig.instance);
  window.localStorage.setItem(
    STORAGE_HM,
    document.location.pathname.split("/")[1].toLowerCase()
  );
};

export const mount = (props) => {
  startChatbot(props.getChatbotProps());
  return Promise.resolve();
};

export const bootstrap = (props) => {
  return Promise.resolve();
};

export const unmount = (props) => {
  window.resetSession();
  return Promise.resolve();
};
